module.exports = __webpack_public_path__ + "static/media/save.cf6bec04.svg";